import { Platform } from '@angular/cdk/platform';
import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { CanColor, mixinColor } from '@angular/material/core';
import { Constructor } from '@angular/material/core/common-behaviors/constructor';
import { MatTable } from '@angular/material/table';

import { RdsCodeDisplayType } from '../core/models/code-display-type.model';
import { RdsNumberFormat } from './models';
import { TabulationTable } from './models/tabulation-table.model';

export class RdsTabulationTableBase {
  constructor(public _elementRef: ElementRef) {}
}

export const _RdsTabulationTableMixinBase: Constructor<CanColor> & typeof RdsTabulationTableBase = mixinColor(
  RdsTabulationTableBase,
  'primary'
);

@Component({
  selector: 'rds-tabulation-table',
  templateUrl: './tabulation-table.component.html',
  styleUrls: ['./tabulation-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RdsTabulationTableComponent extends _RdsTabulationTableMixinBase implements CanColor {
  @ViewChild(MatTable) table!: MatTable<any>;

  @Input() codeDisplay: RdsCodeDisplayType = 'NAME';
  @Input() color: 'primary' | 'accent';
  @Input() displayPropNames: Record<RdsCodeDisplayType, Array<string>> = {
    NAME: ['name'],
    VALUE: ['codeValue'],
    BOTH: ['codeValue', 'name']
  };
  /** The maximum number of digits after the decimal point. Default is 2. */
  @Input() maxFractionDigits: number | string = 2;
  /** The minimum number of digits after the decimal point. Default is 0. */
  @Input() minFractionDigits: number | string = 0;
  /** How the cell values are formatted. Default is NONE */
  @Input() numberFormat: RdsNumberFormat = 'NONE';

  @Input()
  get tabulation() {
    return this._tabulation;
  }
  set tabulation(t: TabulationTable) {
    const prevTabulation = !!this._tabulation;
    this._tabulation = t;
    if (prevTabulation && !!t) {
      // Table Headersthat use 'ngIf' (<tr mat-header-row *ngIf="">) won't rerender
      // when the values change (add subtotals), so we have to force rerender
      this.table.removeHeaderRowDef(null);
      setTimeout(() => this.table.renderRows());
    }
  }
  private _tabulation: TabulationTable;

  constructor(elementRef: ElementRef, public platform: Platform) {
    super(elementRef);
  }
}
